<script>
    import sessionStore from 'store/session'
    import { onMount } from "svelte"
    import AuthHeader from '../../components/AuthHeader.svelte'
    import AuthFooter from '../../components/AuthFooter.svelte'
    import { getQueues as GetQueues, getQueueContacts as GetQueueContacts } from '../../domain/call/queue.action';
    import Icon from '../../components/Icon.svelte';
    import toast from '../../services/toast';
  import { fly } from 'svelte/transition';
  import { backInOut } from 'svelte/easing';
  import { pickOutInitials } from '../../services/utils';

    let queues = [];
    let queue = {};
    let loading = false;
    let loadingStartQueue = false;

    const handleCallQueueClick = async queue => $sessionStore.queue?.id === queue.id ? 
        sessionStore.clearQueue() : await startQueueCall(queue);

    const startQueueCall = async queue => {
        if ( loadingStartQueue ) {
            return
        }
        const { id, name } = queue
        loadingStartQueue = true
        try {
            const { data: pending } = await GetQueueContacts($sessionStore.profile.business.id, id)
            // console.log(response)
            sessionStore.setQueue({
                id,
                pending,
            })
            toast.success(`${name} call queue started`)
        } catch (e) {
            const { message = "Ops, an error occured adding call to queue."} = e;
            toast.error({message})
        } finally {
            loadingStartQueue = false
        }
    }

    const showQueueContact = async (__queue__) => {
        queue = __queue__; 
        await fetchQueueContacts(__queue__)
    }

    const fetchQueueContacts = async queue => {
        const { id } = queue
        loading = true
        try {
            const { data } = await GetQueueContacts($sessionStore.profile.business.id, id)
            queue.contacts = data
        } catch (e) {
            const { message = "Ops, an error occured adding call to queue."} = e;
            toast.error({message})
        } finally {
            loading = false
        }
    }

    const bg_colors = ['from-green-400 to-blue-500', 'from-yellow-400 to-purple-500', 'from-sky-400 to-blue-500', 'from-orange-400 to-red-500', 'from-red-400 to-pink-500']

    onMount( async () => {
        loading = true
        try {
            queues = await GetQueues($sessionStore.profile.business.id)
        } catch (error) {
            console.log(error)
        } finally {
            loading = false
        }
    })
    
</script>

{#if Object.values(queue).length > 0}
<div class="absolute top-0 w-full z-50 bg-white" in:fly={{
    y: 100,
    delay: 100,
    easing: backInOut
  }}
>
    <div class="p-4 bg-gray-100">
        <div class="flex justify-between w-full items-center">
          <div class="flex">
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <div 
                on:click={handleCallQueueClick(queue)}
                class="flex justify-center items-center bg-gradient-to-r {$sessionStore.queue?.id === queue.id ? 'bg-gradient-to-r from-pink-500 to-red-500' : 'primary-bg-color'} {loadingStartQueue ? 'btn-disabled' : ''} rounded-full h-12 w-12 text-white"
            >
                <Icon icon={$sessionStore.queue?.id === queue.id ? "end-call" : "call"} color="#ffffff"/>
            </div>
            <div class="text-sm ml-1">
              <p>{ queue.name }</p>
              <span class="text-xs flex items-center">
                <div class="flex bg-gradient-to-r {$sessionStore.queue?.id === queue.id ? 'from-green-400 to-blue-500' : 'from-red-400 to-pink-500'} rounded-full h-2 w-2 mr-1"></div>
                Queue {$sessionStore.queue?.id === queue.id ? 'Active' : 'Inactive'}
              </span>
            </div>
          </div>
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <span class="p-1 border border-gray-300 rounded-md cursor-pointer" on:click={() => queue = {}}>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.75684 13.2426L13.2421 4.75736" stroke="#173556" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M13.2421 13.2426L4.75684 4.75735" stroke="#173556" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>        
          </span>
        </div>
    </div>
    <div class="m-4">
        {#if queue.contacts && queue.contacts.length > 0}
            {#each queue.contacts as contact, i}
            <div class="p-4 bg-gray-100 rounded mb-2">
                <div class="flex justify-between items-center">
                    <div class="flex items-center">
                        <div class="flex justify-center items-center text-sm bg-gradient-to-r {bg_colors[i%bg_colors.length]} rounded-full h-8 w-8 text-white">
                            { pickOutInitials(contact.name) }
                        </div>
                        <div class="ml-2">
                            <div class="font-light text-xs">{ contact.name }</div>
                        </div>
                    </div>
                    <span class="text-gray-500 text-xs">
                        {contact.number}
                    </span>
                </div>
            </div>
            {/each}
        {:else if loading}
        <div class="flex justify-center items-center h-4/6" style="height: 16rem;">
            <Icon icon="loader" />
            <i class="animate-pulse secondary-text-color">loading record...</i>
        </div>
        {:else}
            <div class="flex justify-center items-center h-4/6" style="height: 16rem;">
                Ops!. No contact in this queue yet.
            </div>
        {/if}
    </div>
</div>
{/if}

<AuthHeader />
<div class="flex h-full flex-col mx-4">
    <h3 class="text-md font-bold mt-2 secondary-text-color">Call Queue</h3>
    <div class="pb-40 overflow-y-scroll h-auto" style="height: 20rem;">
        {#if queues.length > 0}
            {#each queues as queue}
            <div class="flex justify-between my-5">
                <div class="flex items-center">
                    <div class="flex justify-center items-center bg-gradient-to-r {$sessionStore.queue?.id === queue.id ? 'from-green-400 to-blue-500' : 'from-red-400 to-pink-500'} rounded-full h-2 w-2 text-white mr-2"></div>
                    <div>
                        <div class="font-light text-xs">{ queue.name }</div>
                        <div class="text-gray-500 text-xs flex">
                            <span>limit: { queue.limit }</span>
                        </div>
                    </div>
                </div>
                <div class="flex">
                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                    <div class="flex justify-center items-center text-gray-700 mr-2 text-xs underline" on:click={showQueueContact(queue)}>{$sessionStore.queue?.id === queue.id ? 'End' : 'Start'} Calls</div>
                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                    <div class="flex justify-center items-center {$sessionStore.queue?.id === queue.id ? 'bg-gradient-to-r from-pink-500 to-red-500' : 'primary-bg-color'} {loadingStartQueue ? 'btn-disabled' : ''} rounded-full h-10 w-10 text-white" on:click={handleCallQueueClick(queue)}>
                        <Icon icon={$sessionStore.queue?.id === queue.id ? "end-call" : "call"} color="#ffffff"/>
                    </div>
                </div>
            </div>
            {/each}
        {:else if !loading}
            <div class="flex justify-center items-center h-4/6" style="height: 16rem;">
               Ops!. No queue record
            </div>
        {/if}
        {#if loading}
        <div class="flex justify-center items-center h-4/6" style="height: 16rem;">
            <Icon icon="loader" />
            <i class="animate-pulse secondary-text-color">loading record...</i>
        </div>
        {/if}
    </div>
    
</div>
<AuthFooter />
<style>
    .secondary-text-color {
        color: var(--secondary-text-color)
    }
    .primary-bg-color {
        background-color: var(--primary-bg-color)
    }
    .btn-disabled {
        background-color: dimgray;
    }
</style>
